module.exports = __webpack_public_path__ + "img/rblt_pro_2.9da6ca7c.png";